<template>
  <div> 
    <!-- <p>{{ postgres }}</p>  -->
      <p class="mt-0 mb-3 text-center text-body-1 font-weight-medium">
        <!-- SAME 1 seat -->
        <span v-if="postgres.chgtype10to20 === 'same' && postgres.currentseats === 1">{{ postgres.statename }} will continue to have {{ postgres.seats2020 }} seat in Congress<!--  <a href="https://www.census.gov/newsroom/press-kits/2021/2020-census-apportionment-counts.html" target="_blank">based on the 2020 Census</a> --></span>
        <!-- SAME more than 1 seat -->
        <span v-if="postgres.chgtype10to20 === 'same' && postgres.currentseats > 1">{{ postgres.statename }} will continue to have {{ postgres.seats2020 }} seats in Congress<!--  <a href="https://www.census.gov/newsroom/press-kits/2021/2020-census-apportionment-counts.html" target="_blank">based on the 2020 Census</a> --></span>
        <!-- GAIN 1 seat -->
        <span v-else-if="postgres.chgtype10to20 === 'gain' && postgres.change10to20 === 1">{{ postgres.statename }} will <span style="color: var(--prussian-blue); font-weight: bold; font-size: 1.1em;"><em>gain {{ postgres.seats2020 - postgres.currentseats }} seat</em></span> in Congress<!--  <a href="https://www.census.gov/newsroom/press-kits/2021/2020-census-apportionment-counts.html" target="_blank">based on the 2020 Census</a> --></span>
        <!-- GAIN more than 1 seat -->
        <span v-else-if="postgres.chgtype10to20 === 'gain' && postgres.change10to20 > 1">{{ postgres.statename }} will <span style="color: var(--prussian-blue); font-weight: bold; font-size: 1.1em;"><em>gain {{ postgres.seats2020 - postgres.currentseats }} seats</em></span> in Congress<!--  <a href="https://www.census.gov/newsroom/press-kits/2021/2020-census-apportionment-counts.html" target="_blank">based on the 2020 Census</a> --></span>
        <!-- LOSE 1 seat -->
        <span v-else-if="postgres.chgtype10to20 === 'loss' && postgres.change10to20 === -1">{{ postgres.statename }} will <span style="color: var(--imperial-red); font-weight: bold; font-size: 1.1em;"><em>lose {{ Math.abs(postgres.seats2020 - postgres.currentseats) }} seat</em></span> in Congress<!--  <a href="https://www.census.gov/newsroom/press-kits/2021/2020-census-apportionment-counts.html" target="_blank">based on the 2020 Census</a> --></span>
        <!-- LOSE more than 1 seat -->
        <span v-else-if="postgres.chgtype10to20 === 'loss' && postgres.change10to20 < -1">{{ postgres.statename }} will <span style="color: var(--imperial-red); font-weight: bold; font-size: 1.1em;"><em>lose {{ Math.abs(postgres.seats2020 - postgres.currentseats) }} seats</em></span> in Congress<!--  <a href="https://www.census.gov/newsroom/press-kits/2021/2020-census-apportionment-counts.html" target="_blank">based on the 2020 Census</a> --></span>
      </p>

      <!-- TEXT AND MODAL LINK BELOW ONLY FOR PRE-2020 ESTIMATES -->
      <!-- <p
        class="data-note-btn-container text-center ma-0"
        @click="EventBus.$emit('open-modal', 'data-note')"
      >
        <a href="#">Note on measuring district population patterns</a>
        <v-icon small color="grey">mdi-comment-alert-outline</v-icon>
      </p>       -->

    <!-- Show table with current and expected seats for all states -->
    <v-simple-table dense class="table-wrap-scoped mb-1">
      <template v-slot:default>
        <thead v-if="postgres.currentseats > 1 && postgres.seats2020 > 1 || postgres.currentseats > 1 && postgres.seats2020 === 1">
          <tr>
            <th colspan="2" class="text-center">
              <em><strong>How might this impact District {{ parseInt(postgres.geoid.substring(4,2),10) }}?</strong></em>
            </th>
            <!-- <th class="text-right">2021 Apportionment</th> -->
            <!-- <th>
            </th> -->
          </tr>
        </thead>
        <thead v-else-if="postgres.currentseats === 1 && postgres.seats2020 > 1">
          <tr>
            <th colspan="2" class="text-center">
              <em><strong>How might this impact {{ postgres.statename }}'s At-Large district?</strong></em>
            </th>
            <!-- <th class="text-right">2021 Apportionment</th> -->
            <!-- <th>
            </th> -->
          </tr>
        </thead>
        <tbody>
          <!-- # of districts -->
          <tr>
            <td>Congressional districts for {{ postgres.stusps }}</td>
            <td class="text-right" style="color: var(--prussian-blue)"><strong>{{ postgres.seats2020 }}</strong></td>
          </tr>
          <!-- Avg district pop -->
          <tr v-if="postgres.seats2020 > 1 || postgres.currentseats > 1 && postgres.seats2020 === 1">
              <!-- <td>New {{ postgres.stusps }} avg. district pop. (2020)</td> -->
              <td>Average district pop. in {{ postgres.stusps }}</td>
              <td class="text-right">
                {{ Math.round(postgres.stateavg || 0).toLocaleString() }} 
              </td>
            </tr>
          <!-- District population (was estimate based on ACS; after Aug 2021 it's the actual 2020 count -->
          <tr class="font-italic">
            <td>
              <span v-if="postgres.districtname === 'Congressional District (at Large)'">At-large district population</span>
              <!-- <span v-else-if="postgres.statefips === '37'">District {{ parseInt(postgres.geoid.substring(4,2),10) }} population estimate (2015-2019 ACS)</span> -->
              <span v-else>District {{ parseInt(postgres.geoid.substring(4,2),10) }} population</span>
              </td>
            <td width="35%" class="text-right">
              {{ postgres.pop2020.toLocaleString() }}
              <!-- <span v-if="postgres.statefips === '37'">{{ postgres.pop2020.toLocaleString() }}</span>
              <span v-else><a v-bind:href="'https://data.census.gov/cedsci/table?g=5001600US' +
                  postgres.geoid +
                  '&y=2019&d=ACS%201-Year%20Estimates%20Detailed%20Tables&tid=ACSDT1Y2019.B01003'" target="_blank">{{ postgres.pop2020.toLocaleString() }}</a></span> -->
            </td>
          </tr>
          <!-- District pop above/below avg -->
            <tr v-if="postgres.seats2020 > 1">
              <td>
                District {{ parseInt(postgres.geoid.substring(4,2),10) }}
                <span v-if="postgres.popdifffromavg > 0" class="font-weight-bold text-needtoshrink-color">above average</span>
                <span v-if="postgres.popdifffromavg < 0" class="font-weight-bold text-needtoexpand-color">below average</span>
                by ...
              </td>
              <td class="text-right">
                <span v-if="postgres.popdifffromavg > 0" class="text-right font-weight-bold text-needtoshrink-color">{{ Math.abs(Math.round(postgres.popdifffromavg)).toLocaleString() }} people</span>
                <span v-if="postgres.popdifffromavg < 0" class="text-right font-weight-bold text-needtoexpand-color">{{ Math.abs(Math.round(postgres.popdifffromavg)).toLocaleString() }} people</span>
              </td>
            </tr>
          <!-- District deviation -->
            <tr v-if="postgres.seats2020 > 1">
              <td>% difference from avg.</td>
              <td class="text-right">
                <span v-if="postgres.deviation > 0.001" class="font-weight-bold text-needtoshrink-color">{{ (postgres.deviation * 100).toFixed(1) }}%</span>
                <span v-if="postgres.deviation < -0.001" class="font-weight-bold text-needtoexpand-color">{{ (postgres.deviation * 100).toFixed(1) }}%</span>
                <span v-if="postgres.deviation >= -0.001 && postgres.deviation <= 0.001" class="font-weight-regular">0%</span>
              </td>
            </tr>
        </tbody>
      </template>
    </v-simple-table>

<p v-if="postgres.seats2020 > 1" class="text-caption">NOTE: 
  <!-- <span v-if="postgres.statefips === '37'"><strong>Current district population</strong> = 2015-2019 American Community Survey block group population estimates allocated to 2019 districts.</span>
  <span v-else><strong>Current district population</strong> = 2019 American Community Survey (ACS) estimate.</span> <strong>Average district population</strong> = {{ postgres.statename }}'s 2019 ACS population estimate ({{ postgres.statepop2019.toLocaleString() }} people) divided by <strong>{{ postgres.seats2020 }} seats</strong>. <strong>Actual district deviation will be updated</strong> when 2020 Census district population is published. -->
  <strong>Current district population</strong> = 2020 Census. <strong>Average district population</strong> = {{ postgres.statename }}'s <a href="https://www2.census.gov/programs-surveys/decennial/2020/data/01-Redistricting_File--PL_94-171/" target="_blank">2020 population</a> ({{ postgres.statepop2020.toLocaleString() }} people) divided by <strong>{{ postgres.seats2020 }} seats</strong>.
</p>

  </div>
</template>
<script>
import { Enums } from "../../../../data/Config/Config";
import {EventBus} from "../../../../data/EventBus";
export default {
  name: "TablesCongress",
  components: {},
  data: function () {
    return {
      EventBus: EventBus
    };
  },
  mounted: function () {},
  methods: {},
  watch: {},
  computed: {
    postgres: function () {
      return (
        this.$store.getters.getSelectedData[Enums.DATA_SOURCE.POSTGRES] || {}
      );
    },
  },
};
</script>

<style scoped>

</style>